import { Component, inject } from '@angular/core';
import { Router } from "@angular/router";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { PureOriginalService } from "../../service/pure-original.service";
import { GlobalSearchByWinOls } from "../../models/GlobalSearchByWinOls-model";


@Component({
    selector: 'app-search-pure-originals',
    templateUrl: './search-pure-originals.component.html',
    styleUrls: ['./search-pure-originals.component.css']
})
export class SearchPureOriginalsComponent {

    pureOriginalService = inject(PureOriginalService);

    router = inject(Router)

    searchPureOriginalForm = new FormGroup({
        searchString: new FormControl('', [Validators.required])
    })


    constructor() {
        this.searchPureOriginalForm.controls['searchString'].valueChanges.subscribe((value) => {
            this.onSearchInput(value);
        });
        this.restartPureOriginalList();
    }

    /**
     * Cleans and normalizes the search input by:
     * - Trimming leading/trailing whitespace and tabs
     * - Removing trailing .ols extension if present
     */
    private cleanSearchInput(input: string | null): string {
        if (!input) {
            return '';
        }

        // Trim leading/trailing whitespace and tabs
        let cleaned = input.trim();

        // Remove trailing .ols if present (case-insensitive)
        if (cleaned.toLowerCase().endsWith('.ols')) {
            cleaned = cleaned.slice(0, -4);
        }

        return cleaned;
    }

    onSearchInput(searchString: string | null) {
        // Clean and normalize the input
        const cleanedSearchString = this.cleanSearchInput(searchString);

        if (cleanedSearchString.length < 3) {
            this.restartPureOriginalList();
            return;
        }

        this.pureOriginalService.pageNumber.set(0);
        this.pureOriginalService.pageSize.set(5);
        this.pureOriginalService.getGlobalSearchByWinOls(cleanedSearchString.toLowerCase()).subscribe(response => {
            this.pureOriginalService.globalSearchByWinOls.set(response['content']);
        });
    }

    restartPureOriginalList() {
        this.pureOriginalService.globalSearchByWinOls.set([]);
    }

    openPureOriginalDetails(id: number) {
        this.router.navigate(['/app/pure-originals/pure-original-details'], { queryParams: { pureOriginalId: id } });
        this.searchPureOriginalForm.value.searchString = '';
        this.restartPureOriginalList();
    }

    openDetailsBasedOnTable(element: GlobalSearchByWinOls) {
        switch (element.tableName) {
            case 'PURE_ORIGINAL_BASE':
                const queryParams: any = { pureOriginalId: element.id };

                // Extract matching IDs from matchingInfos if available
                if (element.matchingInfos && element.matchingInfos.length > 0) {
                    const matchingIds = element.matchingInfos.map(info => info.pureOriginalMatchingId);
                    queryParams.matchingIds = matchingIds.join(',');
                }

                this.router.navigate(['/app/pure-originals/pure-original-details'], {
                    queryParams: queryParams
                });
                break;

            case 'MASTER':
                this.router.navigate(['/app/master-details', element.id]);
                break;

            case 'VERSION':
                const masterId = element.masterId;
                const versionName = element.versionName?.trim();

                if (!masterId) {
                    console.warn('No masterId available on VERSION element.');
                    return;
                }

                this.router.navigate([`/app/master-details/${masterId}`], {
                    queryParams: { versionName }
                });

                break;

            default:
                console.warn('Unknown table name:', element.tableName);
        }

        this.searchPureOriginalForm.patchValue({ searchString: '' });
        this.restartPureOriginalList();
    }


}
